import { Calendar, Check, MapPin, Trash2 } from "lucide-react";
import React from "react";

import { cn } from "@/app/handlers/cn.utils";
import { dateObjToYMD } from "@/app/handlers/utilityFunctions";

import { JobDetails } from "../FitCheck";

interface JobItemProps {
	job: JobDetails;
	isSelected: boolean;
	onToggle?: () => void;
	onRemove?: () => void;
	showCheckbox?: boolean;
}

export const JobItem = ({ job, isSelected, onToggle, onRemove, showCheckbox = true }: JobItemProps) => {
	return (
		<div
			onClick={onToggle}
			className={cn(
				"flex items-center gap-3 p-3 rounded-lg border transition-all",
				showCheckbox && "cursor-pointer",
				isSelected ? "border-blue-500 bg-white" : "border-gray-200 bg-white hover:border-gray-300",
			)}
		>
			<div className="h-10 w-10 flex-shrink-0 overflow-hidden rounded-lg border border-gray-100">
				<img
					src={job.company?.logo_url || "/images/co-placeholder.png"}
					alt={job.company?.company_name || "Company"}
					className="h-full w-full object-cover"
					onError={(e) => {
						(e.target as HTMLImageElement).src = "/images/co-placeholder.png";
					}}
				/>
			</div>
			<div className="flex-1 min-w-0">
				<h4 className="font-semibold text-gray-900 text-sm">{job.jobTitle}</h4>
				<div className="flex flex-wrap items-center text-xs text-gray-500 mt-0.5">
					<span className="text-nowrap mr-2">{job.company?.company_name || job.companyName}</span>
					<span className="flex items-center gap-1 text-nowrap mr-2">
						<MapPin className="w-3 h-3" />
						{job.jobLocation?.city}, {job.jobLocation?.country || "Tanzania"}
					</span>
					<span className="flex items-center gap-1 text-nowrap">
						<Calendar className="w-3 h-3" />
						{job.deadlineDate ? dateObjToYMD(job.deadlineDate) : "N/A"}
					</span>
				</div>
			</div>
			{showCheckbox && (
				<div
					className={cn(
						"w-5 h-5 rounded-sm border-2 flex items-center justify-center flex-shrink-0 transition-all",
						isSelected ? "bg-blue-500 border-blue-500" : "border-gray-300 bg-white",
					)}
				>
					{isSelected && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
				</div>
			)}
			{onRemove && (
				<button
					onClick={(e) => {
						e.stopPropagation();
						onRemove();
					}}
					className="flex-shrink-0 text-gray-400 hover:text-red-500 transition-colors"
					title="Remove from basket"
				>
					<Trash2 className="w-4 h-4" />
				</button>
			)}
		</div>
	);
};

export default JobItem;
